import React from 'react';

interface GameBoardGridProps {
  categories: { id: string; name: string }[];
  values: number[];
  questions: { answered: boolean; revealed?: boolean; text?: string }[][]; // [category][row]
  onTileClick?: (categoryIdx: number, valueIdx: number) => void;
}

export const GameBoardGrid: React.FC<GameBoardGridProps> = ({ categories, values, questions, onTileClick }) => {
  return (
    <div className="w-full px-1 sm:px-2 md:px-0 max-w-full">
      <table className="w-full border-separate border-spacing-2 sm:border-spacing-4 md:border-spacing-6">
        <thead>
          <tr>
            {categories.map((category) => (
              <th
                key={category.id}
                className="text-xs sm:text-sm md:text-lg font-semibold text-center bg-brand-yellow text-black rounded-xl shadow-md uppercase whitespace-nowrap overflow-hidden text-ellipsis max-w-[60px] sm:max-w-[100px] md:max-w-[200px] border border-[#e6b84c] tracking-wide h-10 sm:h-14 md:h-20 align-middle p-0"
                style={{ verticalAlign: 'middle' }}
                title={category.name}
              >
                <span className="flex items-center justify-center h-full w-full px-1 sm:px-2">{category.name}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {values.map((value, rowIdx) => (
            <tr key={value}>
              {categories.map((category, colIdx) => {
                const question = questions[colIdx]?.[rowIdx] || {};
                return (
                  <td key={category.id + '-' + value} className="align-middle text-center">
                    <div
                      className={`relative w-14 h-12 sm:w-24 sm:h-16 md:w-44 md:h-28 flex items-center justify-center border-2 sm:border-4 border-[#e6b84c] bg-black font-black text-lg sm:text-2xl md:text-4xl uppercase tracking-widest select-none transition-all duration-200 text-center rounded-b-xl sm:rounded-b-2xl shadow-lg drop-shadow-lg mx-auto my-1 sm:my-2
                        ${question.answered ? 'opacity-50 cursor-not-allowed bg-[#181818]' : 'text-brand-yellow cursor-pointer hover:bg-[#222] hover:scale-105 hover:shadow-2xl'}
                        ${question.revealed && !question.answered ? 'opacity-100' : ''}`}
                      style={{ fontFamily: 'inherit' }}
                      tabIndex={-1}
                      onClick={() => !question.answered && onTileClick && onTileClick(colIdx, rowIdx)}
                    >
                      {question.answered && (
                        <img
                          src="/images/white-glasses.svg"
                          alt="Answered"
                          className="absolute inset-0 m-auto"
                          style={{
                            width: '60%',
                            height: '60%',
                            opacity: 0.18,
                            pointerEvents: 'none',
                            zIndex: 1,
                          }}
                        />
                      )}
                      {!question.answered && !question.revealed && (
                        <span className="drop-shadow-[0_2px_4px_rgba(255,215,0,0.5)]">${value}</span>
                      )}
                      {question.revealed && !question.answered && (
                        <span className="font-bold px-1 sm:px-2 text-xs sm:text-lg md:text-2xl text-white z-10">{question.text}</span>
                      )}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}; 